import React, { useEffect, useRef, useState } from "react";
import icon1 from "../../assets/images/setting-icon.svg";
import LoadingPage from "../../components/LoadingPage";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import newsletterPlugin from "grapesjs-preset-newsletter";
import { toast } from "react-toastify";
import {
  editDoctorTemplateApi,
  addOtherDoctorTemplateApi,
  getDoctorTemplateApi,
  editOtherDoctorTemplateApi,
  getOtherDoctorTemplateApi,
  getDoctorOtherTemplateApi,
  uploadTemplateAssetApi,
} from "../../services/apiService";
import { useNavigate, useParams } from "react-router";
import html2canvas from "html2canvas";
import { getQueryParams } from "../../utils/commonData";

const EditPrescriptionByDoctor = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const editorContainer = useRef(null);
  const [screenLoading, setScreenLoading] = useState(false);
  const [screenLoading1, setScreenLoading1] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [cssContent, setCssContent] = useState("");
  const [btnDis, setBtnDis] = useState(false);
  const [templateName, setTemplateName] = useState();
  const [isEditorVisible, setIsEditorVisible] = useState(true);
  const [editorInstanceState, setEditorInstanceState] = useState();
  const [category, setCategory] = useState();
  const [hasChanges, setHasChanges] = useState(false);
  const [originalTemplateData, setOriginalTemplateData] = useState({
    template_body: "",
    style: "",
    template_name: "",
    category: "",
  });

  useEffect(() => {
    if (editorInstanceState && typeof editorInstanceState.getWrapper === 'function' && category) {
      const wrapper = editorInstanceState.getWrapper();
      if (!wrapper) return;
      const allComponents = wrapper.find("*");

      // Search for components containing "PRESCRIPTION" or "ORDONNANCE"
      let componentsToUpdate = allComponents.filter((c) => {
        const content = c.get("content") || "";
        return (
          c.getAttributes().id === "template-title" ||
          /PRESCRIPTION/i.test(content)
        );
      });

      if (category === "1") {
        // "Ordonnance" selected — ensure no title is displayed
        if (componentsToUpdate.length > 0) {
          componentsToUpdate.forEach((titleComp) => {
            try {
              titleComp.remove();
            } catch (e) {}
          });
        }
      } else if (category === "2") {
        // "Document" selected
        componentsToUpdate.forEach((titleComp) => {
          titleComp.remove();
        });
      }
    }
  }, [category, editorInstanceState]);

  const [isAddedByAdmin, setIsAddedByAdmin] = useState(false);

  useEffect(() => {
    let isCancelled = false;
    let editorInstance;
    if (isEditorVisible && editorContainer.current) {
      editorInstance = grapesjs.init({
        container: editorContainer.current,
        fromElement: false,
        storageManager: false, // Disable storage
        blockManager: {
          appendTo: "#blocks", // Container where blocks will be appended
        },
        canvas: {
          styles: [
            "https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap",
          ],
        },
        plugins: [newsletterPlugin],
        assetManager: {
          upload: true,
          uploadName: "files",
          async uploadFile(e) {
            const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
              formData.append("files[]", files[i]);
            }
            try {
              const response = await uploadTemplateAssetApi(formData);
              if (response.data && response.data.res) {
                if (!isCancelled && editorInstance && editorInstance.AssetManager) {
                  editorInstance.AssetManager.add(response.data.data);
                }
              } else {
                toast.error(response.data.msg || "Upload failed");
              }
            } catch (error) {
              console.error("Asset upload error:", error);
              toast.error("Error uploading image");
            }
          },
        },
        avoidInlineStyle: false,
        forceClass: false,
        panels: false,
      });

      // Add A4 page styling to the canvas
      editorInstance.on("load", () => {
        if (isCancelled) return;
        const doc = editorInstance.Canvas.getDocument();
        if (!doc) return;
        const style = doc.createElement("style");
        style.innerHTML = `
           html {
             background-color: #50596c !important;
           }
           body {
             background-color: #50596c !important;
             display: flex !important;
             justify-content: center !important;
             padding: 40px 0 !important;
             margin: 0 !important;
             height: auto !important;
             min-height: 100vh !important;
           }
           /* Target GrapesJS wrapper specifically */
           .gjs-wrapper, #wrapper, [data-gjs-type="wrapper"] {
             width: 210mm !important;
             height: 297mm !important;
             min-height: 297mm !important;
             background-color: white !important;
             box-shadow: 0 0 30px rgba(0,0,0,0.5) !important;
             margin: 0 auto !important;
             overflow: hidden !important;
             position: relative !important;
             box-sizing: border-box !important;
             display: block !important;
           }
           /* Ensure all direct children of the wrapper fit the A4 width */
           .gjs-wrapper > *, #wrapper > * {
             max-width: 100% !important;
           }
           /* Ensure the dashed outline follows the A4 size */
           .gjs-dashed *[data-gjs-type="wrapper"], .gjs-dashed .gjs-wrapper {
             width: 210mm !important;
             height: 297mm !important;
           }

           /* Prevent empty elements from collapsing in the editor */
           div:empty, section:empty, td:empty {
             min-height: 14px;
           }
         `;
        if (doc.head) {
          doc.head.appendChild(style);
        }
      });

      editorInstance.BlockManager.add("custom-text-block", {
        label: "Texte", // Label for the block that appears in the block panel
        content: `
          <div class="custom-text-block" style="font-size: 14px; margin: 0;">
            <span>Entrez votre texte ici...</span>
          </div>
        `,
        // category: "Basic", // Category under which the block will be listed in the panel
        attributes: {
          title: "Faites glisser pour ajouter un bloc de texte personnalisé",
        }, // Tooltip for the block
      });

      // Custom Patient Card component type
      editorInstance.DomComponents.addType("patient-card", {
        model: {
          defaults: {
            tagName: "div",
            attributes: { class: "patient-card" },
            components: [
              {
                type: "text",
                content: "[patient-name-age-gender]",
                classes: ["patient-info"],
              },
              {
                type: "text",
                content: "[patient-address-block]",
                classes: ["patient-address"],
              },
            ],
            styles: `
              .patient-card { margin-bottom: 10px; }
              .patient-info { font-size: 14px; display:block; margin: 0; padding: 0; }
              .patient-address { font-size: 14px; display:block; margin: 0; padding: 0; }
            `,
          },
        },
      });

      // Custom Doctor Card component type
      editorInstance.DomComponents.addType("doctor-card", {
        model: {
          defaults: {
            tagName: "div",
            attributes: { class: "doctor-card" },
            components: [
              { type: "text", content: "[docteur-name]", classes: ["doc-name"] },
              {
                type: "text",
                content: "[docteur-speciality]",
                classes: ["doc-speciality"],
              },
              {
                type: "text",
                content: "[docteur-reg-number]",
                classes: ["doc-reg"],
              },
              {
                type: "text",
                content: "[docteur-clinic-name]",
                classes: ["doc-clinic"],
              },
              {
                type: "text",
                content: "[docteur-address-one]",
                classes: ["doc-addr1"],
              },
              {
                type: "text",
                content: "[docteur-address-two]",
                classes: ["doc-addr2"],
              },
              {
                type: "text",
                content: "[docteur-phone]",
                classes: ["doc-phone"],
              },
              {
                type: "text",
                content: "[docteur-email]",
                classes: ["doc-email"],
              },
            ],
            styles: `
              .doctor-card { padding: 10px; border: none; }
              .doc-name { font-size: 20px; font-weight: bold; display:block; margin: 0; }
              .doc-speciality { font-size: 16px; color: #555; display:block; margin: 0; }
              .doc-reg { font-size: 14px; display:block; margin: 0; }
              .doc-clinic { font-size: 14px; display:block; margin: 0; }
              .doc-addr1 { font-size: 14px; display:block; margin: 0; }
              .doc-addr2 { font-size: 14px; display:block; margin: 0; }
              .doc-phone { font-size: 14px; display:block; margin: 0; }
              .doc-email { font-size: 14px; display:block; margin: 0; }
            `,
          },
        },
      });

      editorInstance.BlockManager.add("custom-Medication-block", {
        label: "Médicaments",
        content: `
          <div class="text-section" style="font-size: 14px; margin: 0; padding: 0; height: auto;">
            <div style="margin: 0; padding: 0;">[Médicaments]</div>
          </div> `,
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-Doctor-Name-block", {
        label: "Nom du docteur",
        content: `<span>[docteur-name]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Info-Block", {
        label: "Doctor Info Block",
        content: { type: "doctor-card" },
      });

      editorInstance.BlockManager.add("custom-Doctor-Speciality-block", {
        label: "Spécialité du docteur",
        content: `<span>[docteur-speciality]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Reg-block", {
        label: "Matricule du docteur",
        content: `<span>[docteur-reg-number]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Clinic-block", {
        label: "Nom de la clinique",
        content: `<span>[docteur-clinic-name]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Address-One-block", {
        label: "Adresse 1 du docteur",
        content: `<span>[docteur-address-one]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Address-Two-block", {
        label: "Adresse 2 du docteur",
        content: `<span>[docteur-address-two]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Phone-block", {
        label: "Téléphone du docteur",
        content: `<span>[docteur-phone]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Email-block", {
        label: "Email du docteur",
        content: `<span>[docteur-email]</span>`,
      });

      editorInstance.BlockManager.add("custom-Doctor-Details-block", {
        label: "Détails du médecin",
        content: `
          <div class="text-section" style="font-size: 14px; margin: 0; padding: 0; height: auto;">
            <div style="margin: 0; padding: 0;">[Détails du médecin]</div>
          </div> `,
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-Patient-Details-block", {
        label: "Détails du patient",
        content: { type: "patient-card" },
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-Date-block", {
        label: "Date",
        content: `<span style="font-size: 14px; margin: 0; display: inline-block;">Date: [date]</span>`,
        // category: "Basic",
      });

      editorInstance.BlockManager.add("custom-qr-code-block", {
        label: "Code QR",
        content: `
          <div class="qr-code-container" style="display: inline-block; width: 80px; height: 80px; border: 1px dashed #ccc; background-color: #f9f9f9; text-align: center; padding: 0; margin: 0; overflow: hidden;">
            <div style="font-size: 10px; color: #999; line-height: 80px; margin: 0; padding: 0;">[code qr]</div>
          </div>
        `,
      });

      editorInstance.BlockManager.getAll().remove("link");
      editorInstance.BlockManager.getAll().remove("link-block");
      editorInstance.BlockManager.getAll().remove("text");
      editorInstance.BlockManager.getAll().remove("text-sect");
      editorInstance.BlockManager.getAll().remove("quote");
      editorInstance.BlockManager.getAll().remove("button");
      editorInstance.BlockManager.getAll().remove("link");
      editorInstance.BlockManager.getAll().remove("link-block");
      editorInstance.BlockManager.getAll().remove("list-items");
      editorInstance.BlockManager.getAll().remove("grid-items");

      // Clear any default content added by the plugin
      editorInstance.on("load", () => {
        const wrapper = editorInstance.getWrapper();
        if (wrapper) {
          wrapper.components([]);
        }
      });

      const fetchData = async () => {
        try {
          if (!isCancelled) setScreenLoading1(true);
          let formData = new FormData();
          formData.append("id", templateId);

          let response;
          if (getQueryParams().get("type") === "other") {
            response = await getOtherDoctorTemplateApi(formData);
          } else {
            response = await getDoctorOtherTemplateApi(formData);
          }

          if (isCancelled) return;

          if (response && editorInstance && typeof editorInstance.setComponents === 'function') {
            if (response.data.res === true && response.data.data) {
              function applyBackgroundImageToWrapper(styleString, bodyId) {
                if (!styleString || typeof styleString !== "string")
                  return styleString;

                const bodyIdSelector = `#${bodyId}`;
                const backgroundImageRegex =
                  /background(?:-image)?:\s*url\(['"]?([^'"\)]+)['"]?\)/i;

                let updatedStyle = styleString;
                
                // In the editor, we want to target the wrapper, not the body.
                // The wrapper in GrapesJS can be targeted via its ID or the special wrapper selector.
                if (bodyId && styleString.includes(bodyIdSelector)) {
                  updatedStyle = styleString.replace(
                    new RegExp(bodyIdSelector.replace(/[#.:]/g, "\\$&"), "g"),
                    '[data-gjs-type="wrapper"]',
                  );
                } else {
                   // If no specific body ID, and there's a body selector, replace it with wrapper selector
                   updatedStyle = updatedStyle.replace(/body\s*{/gi, '[data-gjs-type="wrapper"] {');
                }

                const match = updatedStyle.match(backgroundImageRegex);
                if (match) {
                  const backgroundImageUrl = match[1];
                  updatedStyle = updatedStyle.replace(
                    backgroundImageRegex,
                    `background-image:url('${backgroundImageUrl}')`,
                  );
                  updatedStyle = updatedStyle.replace(
                    /\[data-gjs-type="wrapper"\]\s*{([^}]*)}/i,
                    (m, decls) => {
                      let newDecls = decls;
                      if (!/background-size\s*:/i.test(decls))
                        newDecls += " background-size: auto;";
                      if (!/background-position\s*:/i.test(decls))
                        newDecls += " background-position: center top;";
                      if (!/background-repeat\s*:/i.test(decls))
                        newDecls += " background-repeat: no-repeat;";
                      return `[data-gjs-type="wrapper"] {${newDecls} }`;
                    },
                  );
                }

                return updatedStyle;
              }

              function loadTemplateFromHtmlCss(editorInstance, templateBody, templateStyle) {
                if (typeof editorInstance.setComponents === 'function') {
                  // Let GrapesJS manage the components properly for editing
                  editorInstance.setComponents(templateBody);
                  
                  // Inject the original styles directly to preserve them (higher specificity)
                  if (templateStyle) {
                    const canvasDoc = editorInstance.Canvas.getDocument();
                    const styleEl = canvasDoc.createElement('style');
                    styleEl.id = 'prescription-template-style';
                    styleEl.textContent = templateStyle;
                    const existingStyle = canvasDoc.getElementById('prescription-template-style');
                    if (existingStyle) {
                      existingStyle.remove();
                    }
                    canvasDoc.head.appendChild(styleEl);
                    
                    // Also let GrapesJS know about the styles
                    editorInstance.setStyle(templateStyle);
                  }
                  
                  // Apply background image fix as well
                  let updatedStyle = templateStyle;
                  if (templateBody && templateStyle) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(templateBody, "text/html");
                    const wrapperElement = doc.body.firstElementChild;
                    const bodyId = wrapperElement ? wrapperElement.id : null;
                    updatedStyle = applyBackgroundImageToWrapper(templateStyle, bodyId);
                  }

                  // FORCE background image onto the wrapper using GrapesJS API
                  if (templateStyle) {
                    const backgroundImageRegex = /background(?:-image)?:\s*url\(['"]?([^'"\)]+)['"]?\)/i;
                    const match = templateStyle.match(backgroundImageRegex);
                    if (match) {
                      const backgroundImageUrl = match[1];
                      let bgSize = "auto";
                      let bgPosition = "center top";
                      let bgRepeat = "no-repeat";
                      
                      const bgSizeMatch = templateStyle.match(/background-size\s*:\s*([^;]+)/i);
                      const bgPosMatch = templateStyle.match(/background-position\s*:\s*([^;]+)/i);
                      const bgRepeatMatch = templateStyle.match(/background-repeat\s*:\s*([^;]+)/i);
                      
                      if (bgSizeMatch) bgSize = bgSizeMatch[1].trim();
                      if (bgPosMatch) bgPosition = bgPosMatch[1].trim();
                      if (bgRepeatMatch) bgRepeat = bgRepeatMatch[1].trim();
                      
                      const wrapper = editorInstance.getWrapper();
                      if (wrapper) {
                        wrapper.addStyle({
                          "background-image": `url('${backgroundImageUrl}')`,
                          "background-size": bgSize,
                          "background-position": bgPosition,
                          "background-repeat": bgRepeat,
                        });
                      }
                    }
                  }
                }
              }

              const templateBody = response.data.data.template_body || "";
              const templateStyle = response.data.data.style || "";
              const projectData = response.data.data.project_data;

              if (editorInstance) {
                // Check if we have project_data (preferred)
                if (projectData) {
                  try {
                    const parsedProjectData = typeof projectData === 'string' 
                      ? JSON.parse(projectData) 
                      : projectData;
                    editorInstance.loadProjectData(parsedProjectData);
                  } catch (e) {
                    console.error('Failed to load project data, falling back to HTML/CSS:', e);
                    // Fallback to HTML/CSS if project data fails
                    loadTemplateFromHtmlCss(editorInstance, templateBody, templateStyle);
                  }
                } else {
                  // No project data, use HTML/CSS
                  loadTemplateFromHtmlCss(editorInstance, templateBody, templateStyle);
                }
              }
                


              if (!isCancelled) {
                setTemplateName(response.data.data.template_name);
                setCategory(response.data.data.category ? response.data.data.category.toString() : "");
                setOriginalTemplateData({
                  template_body: response.data.data.template_body || "",
                  style: response.data.data.style || "",
                  template_name: response.data.data.template_name || "",
                  category: response.data.data.category ? response.data.data.category.toString() : "",
                });
              }
            } else {
              if (response.data.msg && !isCancelled) {
                toast.error(response.data.msg, { autoClose: 1500 });
              }
            }
          }
        } catch (error) {
          console.error(error);
          if (!isCancelled) {
            toast.error("Something went wrong in server. Please try again.", {
              autoClose: 1500,
            });
          }
        } finally {
          if (!isCancelled) setScreenLoading1(false);
        }
      };

      // Call fetchData to load the components on mount
      fetchData();

      editorInstance.on("component:add", () => {
        if (isCancelled) return;
        setHasChanges(true);
        const html = editorInstance.getHtml();
        const css = editorInstance.getCss();

        // Merge HTML and CSS
        // const mergedHtml = mergeHtmlWithInlineStyles(html, css);
        setHtmlContent(html);
        setCssContent(css);
      });

      editorInstance.on("component:update", () => {
        if (isCancelled) return;
        setHasChanges(true);
        const html = editorInstance.getHtml();
        const css = editorInstance.getCss();

        // Merge HTML and CSS
        // const mergedHtml = mergeHtmlWithInlineStyles(html, css);
        setHtmlContent(html);
        setCssContent(css);
      });

      editorInstance.on("storage:load", () => {
        if (isCancelled) return;
        setHasChanges(true);
        const html = editorInstance.getHtml();
        const css = editorInstance.getCss();

        // Merge HTML and CSS
        // const mergedHtml = mergeHtmlWithInlineStyles(html, css);
        setHtmlContent(html);
        setCssContent(css);
      });
      setEditorInstanceState(editorInstance);
    }

    return () => {
      isCancelled = true;
      if (editorInstance) {
        editorInstance.destroy();
      }
    };
  }, [isEditorVisible, editorContainer.current]);

  // Function to merge inline styles into the HTML content
  function mergeHtmlWithInlineStyles(html, css) {
    // Parse the CSS to get class/id-based styles
    const styleTags = parseCssToInline(css);

    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    // Loop through each element and apply inline styles
    const elements = tempDiv.querySelectorAll("*");

    elements.forEach((el) => {
      const className = el.id;
      if (className && styleTags[className]) {
        el.style.cssText = styleTags[className];
      }
    });

    // Return the modified HTML
    return tempDiv.innerHTML;
  }

  // Function to parse the CSS rules and return inline styles
  function parseCssToInline(css) {
    const styleTags = {};
    const rules = css.split("}");

    rules.forEach((rule) => {
      const parts = rule.split("{");
      if (parts.length === 2) {
        const selector = parts[0].trim();
        const declarations = parts[1].trim();

        // Handle both class and id selectors
        if (selector.startsWith(".")) {
          styleTags[selector.slice(1)] = declarations;
        } else if (selector.startsWith("#")) {
          styleTags[selector.slice(1)] = declarations;
        }
      }
    });

    return styleTags;
  }

  const captureTemplateImage = () => {
    return new Promise((resolve, reject) => {
      if (editorInstanceState) {
        // Find the container you want to capture (e.g., the full editor preview)
        const editorContainerEl = document.querySelector(".gjs-frame-wrapper");

        const iframe = editorContainerEl.querySelector("iframe");

        if (iframe && iframe.contentWindow) {
          // Only works if iframe is on the same domain
          html2canvas(iframe.contentWindow.document.body)
            .then((iframeCanvas) => {
              // Use toBlob correctly by passing a callback function
              iframeCanvas.toBlob((blob) => {
                if (blob) {
                  // Convert Blob to a File
                  const file = new File([blob], "template-image.png", {
                    type: "image/png", // MIME type
                    lastModified: Date.now(),
                  });

                  // Return the File through the Promise
                  resolve(file);
                } else {
                  reject("Failed to create Blob from canvas");
                }
              }, "image/png");
            })
            .catch((error) => {
              reject("Error capturing iframe canvas: " + error);
            });
        } else {
          reject("Iframe or contentWindow is not available");
        }
      } else {
        reject("Editor instance is not available");
      }
    });
  };

  const handleSaveContent = async () => {
    // if (isAddedByAdmin) {
    //   alert(true);
    // } else {
    //   alert(false);
    // }
    // return;
    if (!templateName) {
      toast.warning("Please enter template name.", { autoClose: 1500 });
    } else if (!category) {
      toast.warning("Please select category.", { autoClose: 1500 });
    } else {
      try {
        setBtnDis(true);
        let formData = new FormData();
        // formData.append("user_id", "0");
        formData.append("template_name", templateName || "");
        
        // Determine if we should use original data or editor-processed data
        const hasNameOrCategoryChanged = 
          templateName !== originalTemplateData.template_name || 
          category !== originalTemplateData.category;
          
        let fullHtml, finalStyle;
        
        if (hasChanges || hasNameOrCategoryChanged) {
          // Capture the actual rendered HTML from the iframe to preserve exact styles
          const frameWrapper = document.querySelector(".gjs-frame-wrapper");
          const iframe = frameWrapper ? frameWrapper.querySelector("iframe") : null;
          
          if (iframe && iframe.contentWindow && iframe.contentDocument) {
            const iDoc = iframe.contentDocument;
            // Extract only the wrapper (A4 page) content, not the entire body with background
            const wrapper = iDoc.querySelector('.gjs-wrapper, #wrapper, [data-gjs-type="wrapper"]');
            if (wrapper) {
              fullHtml = wrapper.innerHTML;
            } else {
              fullHtml = iDoc.body.innerHTML;
            }
            
            let styles = '';
            const styleTags = iDoc.querySelectorAll('head style');
            styleTags.forEach(tag => {
              let styleText = tag.textContent;
              // Filter out GrapesJS editor-specific styles
              // Remove any styles that target html, body, .gjs-*, #wrapper, [data-gjs-*]
              styleText = styleText.replace(/(html|body|\.gjs-\S+|#wrapper|\[data-gjs-[^\]]+\])\s*\{[^}]*\}/gi, '');
              // Also remove any styles with background-color #50596c or background #50596c
              styleText = styleText.replace(/\{[^}]*background(?:-color)?:\s*#[50596c|50596c][^}]*\}/gi, '');
              styles += styleText + '\n';
            });
            finalStyle = styles;
          } else {
            // Fallback if iframe not available
            const wrapper = editorInstanceState.getWrapper();
            fullHtml = editorInstanceState.getHtml({
              attributes: true,
              components: true,
            });
            
            const editorCss = editorInstanceState.getCss({
              keepUnusedStyles: true
            }) || "";
            
            let filteredEditorCss = editorCss;
            // Filter out GrapesJS editor-specific styles in fallback case as well
            filteredEditorCss = filteredEditorCss.replace(/(html|body|\.gjs-\S+|#wrapper|\[data-gjs-[^\]]+\])\s*\{[^}]*\}/gi, '');
            filteredEditorCss = filteredEditorCss.replace(/\{[^}]*background(?:-color)?:\s*#[50596c|50596c][^}]*\}/gi, '');
            
            finalStyle = filteredEditorCss.replace(/\[data-gjs-type="wrapper"\]/g, 'body');
            if (wrapper && wrapper.get('attributes').id) {
              finalStyle = finalStyle.replace(new RegExp('#' + wrapper.get('attributes').id, 'g'), 'body');
            }
          }
        } else {
          // No changes, use original data
          fullHtml = originalTemplateData.template_body;
          finalStyle = originalTemplateData.style;
        }

        // Validation for QR code placeholder
        if (
          !fullHtml.includes("[code qr]") &&
          !fullHtml.includes("[qr code]") &&
          !fullHtml.includes("[qrcode]") &&
          !fullHtml.includes("[qr]")
        ) {
          toast.warning(
            "You forgot to add the QR code, please add it to save the template",
            { autoClose: 3000 }
          );
          setBtnDis(false);
          return;
        }

        formData.append("template_body", fullHtml);
        formData.append("style", finalStyle);
        formData.append("category", category);
        // Add GrapesJS project data
        if (editorInstanceState) {
          const projectData = editorInstanceState.getProjectData();
          formData.append("project_data", JSON.stringify(projectData));
        }

        // Extract font settings by reading computed styles from the GrapesJS iframe
        // This is the most reliable approach: read what the browser actually renders
        try {
          const DOCTOR_PLACEHOLDERS = [
            "[Détails du médecin]",
            "[Doctor Details]",
            "[détails du médecin]",
            "Détails du médecin",
            "Doctor Details",
          ];
          const PATIENT_PLACEHOLDERS = [
            "[Détails du patient]",
            "[Patient Details]",
            "[détails du patient]",
            "Détails du patient",
            "Patient Details",
          ];

          // ── Méthode 1 : computed styles depuis l'iframe GrapesJS ──────────────
          const extractFromIframe = (placeholders) => {
            try {
              const frameWrapper = document.querySelector(".gjs-frame-wrapper");
              const iframe = frameWrapper
                ? frameWrapper.querySelector("iframe")
                : null;
              if (!iframe || !iframe.contentWindow) return null;
              const iDoc = iframe.contentWindow.document;
              const iWin = iframe.contentWindow;
              const allEls = iDoc.querySelectorAll("*");
              for (const el of allEls) {
                const text = el.textContent || "";
                if (placeholders.some((p) => text.includes(p))) {
                  // Remonter jusqu'à 4 niveaux pour trouver le style
                  let node = el;
                  for (let d = 0; d < 4; d++) {
                    if (!node || node === iDoc.body) break;
                    const cs = iWin.getComputedStyle(node);
                    const fontSize = cs.getPropertyValue("font-size") || "";
                    const fontFamily = cs.getPropertyValue("font-family") || "";
                    // Ignorer la valeur par défaut du navigateur (16px)
                    if (
                      fontSize &&
                      fontSize !== "16px" &&
                      fontSize !== "14px"
                    ) {
                      return {
                        fontSize: fontSize.trim() || null,
                        fontFamily: fontFamily.trim() || null,
                      };
                    }
                    node = node.parentElement;
                  }
                }
              }
            } catch (e) {
              /* cross-origin ou iframe non disponible */
            }
            return null;
          };

          // ── Méthode 2 : CSS généré par GrapesJS (classes + inline) ───────────
          const extractFromGeneratedCss = (placeholders) => {
            try {
              const editorHtml = editorInstanceState.getHtml() || "";
              const editorCss = editorInstanceState.getCss() || "";

              // Construire la map className -> styles depuis le CSS GrapesJS
              const cssMap = {};
              const ruleRe = /\.([\w-]+)\s*\{([^}]*)\}/g;
              let rm;
              while ((rm = ruleRe.exec(editorCss)) !== null) {
                const cls = rm[1],
                  decls = rm[2];
                const fs = (decls.match(/font-size\s*:\s*([^;]+)/i) || [])[1];
                const ff = (decls.match(/font-family\s*:\s*([^;]+)/i) || [])[1];
                if (fs || ff)
                  cssMap[cls] = {
                    fontSize: (fs || "").trim() || null,
                    fontFamily: (ff || "").trim() || null,
                  };
              }

              const getFromEl = (el) => {
                // style inline d'abord
                const s = el.getAttribute("style") || "";
                const fs = (s.match(/font-size\s*:\s*([^;]+)/i) || [])[1];
                const ff = (s.match(/font-family\s*:\s*([^;]+)/i) || [])[1];
                if (fs || ff)
                  return {
                    fontSize: (fs || "").trim() || null,
                    fontFamily: (ff || "").trim() || null,
                  };
                // puis classes CSS
                for (const cls of Array.from(el.classList || [])) {
                  if (cssMap[cls]) return cssMap[cls];
                }
                return null;
              };

              const parser = new DOMParser();
              const doc = parser.parseFromString(editorHtml, "text/html");
              for (const el of doc.querySelectorAll("*")) {
                if (
                  placeholders.some((p) => (el.textContent || "").includes(p))
                ) {
                  let node = el;
                  for (let d = 0; d < 4; d++) {
                    if (!node) break;
                    const r = getFromEl(node);
                    if (r && (r.fontSize || r.fontFamily)) return r;
                    node = node.parentElement;
                  }
                }
              }
            } catch (e) {}
            return null;
          };

          // ── Méthode 3 : API GrapesJS getStyle() récursif ─────────────────────
          const extractFromGjsApi = (placeholders) => {
            try {
              const walk = (comps) => {
                for (let i = 0; i < comps.length; i++) {
                  const c = comps.at(i);
                  let h = "";
                  try {
                    h = c.toHTML();
                  } catch (e) {}
                  const sources = [
                    c.get("content") || "",
                    c.get("innerHTML") || "",
                    h,
                  ];
                  if (
                    sources.some((s) => placeholders.some((p) => s.includes(p)))
                  ) {
                    // Chercher sur ce composant et ses ancêtres
                    let node = c;
                    for (let d = 0; d < 4; d++) {
                      if (!node) break;
                      const st = node.getStyle ? node.getStyle() || {} : {};
                      const fs = st["font-size"] || null;
                      const ff = st["font-family"] || null;
                      if (fs || ff) return { fontSize: fs, fontFamily: ff };
                      node = node.parent ? node.parent() : null;
                    }
                  }
                  const children = c.components();
                  if (children && children.length) {
                    const res = walk(children);
                    if (res) return res;
                  }
                }
                return null;
              };
              return walk(editorInstanceState.getWrapper().components());
            } catch (e) {}
            return null;
          };

          // Appliquer les 3 méthodes dans l'ordre, prendre la première qui trouve
          const resolveFont = (placeholders) => {
            return (
              extractFromIframe(placeholders) ||
              extractFromGeneratedCss(placeholders) ||
              extractFromGjsApi(placeholders) ||
              null
            );
          };

          const doctorStyles = resolveFont(DOCTOR_PLACEHOLDERS);
          const patientStyles = resolveFont(PATIENT_PLACEHOLDERS);

          console.log("[FONT] doctor:", doctorStyles);
          console.log("[FONT] patient:", patientStyles);

          if (patientStyles?.fontFamily)
            formData.append("patient_font_family", patientStyles.fontFamily);
          if (patientStyles?.fontSize)
            formData.append("patient_font_size", patientStyles.fontSize);
          if (doctorStyles?.fontFamily)
            formData.append("doctor_font_family", doctorStyles.fontFamily);
          if (doctorStyles?.fontSize)
            formData.append("doctor_font_size", doctorStyles.fontSize);
        } catch (e) {
          console.error("Error extracting font styles:", e);
        }

        const templateBlob = await captureTemplateImage(); // Wait for the image to be captured
        formData.append("template_image", templateBlob);

        let response;
        if (getQueryParams().get("type") === "other") {
          formData.append("id", templateId);
          formData.append("type", "");
          response = await editOtherDoctorTemplateApi(formData);
        } else {
          formData.append("doctor_templates_id", templateId);
          formData.append(
            "type",
            getQueryParams().get("type") === "other" || isAddedByAdmin ? "other" : "",
          );
          response = await addOtherDoctorTemplateApi(formData);
        }

        if (response) {
          if (response.data.res === true) {
            toast.success(response.data.msg || "Edited successfully.", {
              autoClose: 1500,
            });
            handleCancel();
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      } finally {
        setBtnDis(false);
      }
    }
  };

  const handleCancel = () => {
    navigate(`/doctor/prescription-management`);
  };

  return (
    <div className="AdminPresManage">
      {screenLoading1 && <LoadingPage />}
      {screenLoading ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="hdnDiv nurseTop">
            <h2>
              <span>
                <img src={icon1} alt="Configuration icon" />
                Modifier le modèle d'ordonnance
              </span>
              <div className="btnSection">
                <input
                  type="text"
                  placeholder="Entrer le nom du modèle"
                  className="FormControl SelectForm"
                  value={templateName}
                  onChange={(e) => setTemplateName(e.target.value)}
                />
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  className="FormControl SelectForm"
                >
                  <option value="" selected hidden>
                    Choisir une catégorie
                  </option>
                  <option value="1">Ordonnance</option>
                  <option value="2">Document</option>
                </select>

                <button
                  className="saveBtn"
                  onClick={handleSaveContent}
                  disabled={btnDis}
                >
                  {btnDis ? "Veuillez patienter..." : "Enregistrer"}
                </button>
                <button className="cancelBtn" onClick={handleCancel}>
                  Annuler
                </button>
              </div>
            </h2>
          </div>
          <div style={{ display: "flex" }}>
            {/* Blocks Container */}
            <div
              id="blocks"
              style={{
                width: "300px",
                borderRight: "1px solid #ddd",
                height: "100vh",
                overflow: "auto",
              }}
            ></div>

            {/* GrapesJS Editor Container */}
            <div
              className="grapesEditorContainer"
              ref={editorContainer}
              id="gjsAdmin"
              style={{ height: "100vh", width: "100%" }}
            />
            {/* <button>Get html and css</button> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditPrescriptionByDoctor;
